<div class="app-overlay">
    <div>
        <span><img id="overlayImage" #overlayImage src="/assets/img/loader-sm.gif" [ngClass]="imgClass" /></span><br/><br/><br/>
        <span>{{getLabelTranslation("Loading")}}</span>
    </div>
</div>
